export default __webpack_public_path__ + "static/media/logout.86ce340e.svg";